import React from 'react';
import './device.css';

import carIcon from '../../../assets/icons/icon-waiting-time.svg';

const Device = ({ id, name, color, iconColor, isRetracted, isVisible, onToggle }) => {
    return (
        <div className={`device_container ${isRetracted ? 'retracted' : ''} ${isVisible ? '' : 'visible'}`} onClick={onToggle} >
            <div className='device_icon' style={{ backgroundColor: color, color: iconColor }}>
                {/* <img src={carIcon} alt={name}></img> */}
                <span className="material-symbols-outlined">directions_car</span>
            </div>
            <span className='device_name'>{name}</span>
            <span className="material-symbols-outlined">{isVisible ? 'visibility' : 'visibility_off' }</span>
        </div>
    );
};

export default Device;
